import { Box, Button, Typography, styled } from "@mui/material"

export const modalContainerStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    height: "fit-content",
    bgcolor: "background.paper",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    paddingBottom: "15px",
    borderRadius: "8px"
}

export const ModalHeader = styled(Box)({
    width: "100%",
    height: "30px",
    display: "flex",
    justifyContent: "flex-end",
})

export const ButtonContainer = styled(Box)({
    alignSelf: "flex-end",
    justifySelf: "flex-end",
    display: "flex",
    height: "fit-content",
    justifyContent: "center",
    width: "100%",
    // border: "1px solid red",
    marginTop: "auto",
    // padding: "0 20px"
})

export const CancelButton = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "138px",
    height: "40px",
    borderRadius: "4px",
    outline: "1px solid #4A79E7",
    cursor: "pointer"
})

export const ConfirmButton = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "138px",
    height: "40px",
    borderRadius: "4px",
    marginLeft: "38px",
    backgroundColor: "#4A79E7",
    cursor: "pointer"
})